import RefreshIcon from "@mui/icons-material/Refresh";
import { IconButton, Stack, Typography } from "@mui/material";
import LoadingIndicator from "./LoadingIndicator";
import { PropsWithChildren } from "react";

type Props = PropsWithChildren & {
    failed?: boolean;
    onRetry?: () => void;
    spacing?: number;
};

export default function Loading({
    failed = false,
    onRetry,
    spacing = 3,
    children,
}: Props) {
    if (failed) {
        return (
            <Stack
                textAlign="center"
                spacing={spacing}
                alignItems="center"
                justifyContent="center"
            >
                <IconButton size="large" onClick={onRetry}>
                    <RefreshIcon sx={{ fontSize: 50 }} />
                </IconButton>
                {children ? (
                    children
                ) : (
                    <>
                        <Typography>Connection failed</Typography>
                        <Typography>Try again</Typography>
                    </>
                )}
            </Stack>
        );
    }

    return <LoadingIndicator />;
}
